import primaryButton from '../../../../primary-button';

const primary = (params) => primaryButton.brandedSolid.background.disabled.primary(params);

export default primary;
